export enum Language {
  en = "en",
  de = "de"
}
